import React from 'react';
import cotalityLogo from 'img/cotality-logo.svg';

import {Menu} from 'semantic-ui-react';
import './FAQHeader.scss';

function FAQHeader() {
    return (
        <header className="faq-header">
            <Menu className="faq-header__menu-top" secondary size="large">
                <Menu.Item className="faq-header__menu-top__logo">
                    <img src={cotalityLogo} alt=""/>
                </Menu.Item>
                <Menu.Item href="https://www.cotality.com/nz">Corporate</Menu.Item>
            </Menu>
        </header>
    );
}

export default FAQHeader;